module.exports = __webpack_public_path__ + "static/media/ana-rebeca.21c52074.jpeg";